export function format_price(price) {
    return `${document.documentElement.dataset.currencySymbol} ${(parseInt(price) / 100).toFixed(2)}`
}
